import {
    IdentityProviderUpdateRequest,
    IIdentityProviderResponse,
    IIdentityProviderUpdateRequest,
} from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';

function createUpdateResponse(
    identityProvider: IIdentityProviderResponse,
): IIdentityProviderUpdateRequest {
    return {
        Name: identityProvider.Name,
        UsernameIdentifiers: identityProvider.UsernameIdentifiers,
    };
}

export async function updateIdentityProvider(
    identityProvider: IIdentityProviderResponse,
    updates: Partial<IIdentityProviderUpdateRequest>,
) {
    const initialValue = createUpdateResponse(identityProvider);
    return sdClient.updateIdentityProvider({
        id: identityProvider.Id,
        body: new IdentityProviderUpdateRequest({ ...initialValue, ...updates }),
    });
}
